import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export function useFetch(path, { poll = 0, enabled = true, deps = [] } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const pollRef = useRef(poll);
  pollRef.current = poll;

  const load = useCallback(async () => {
    if (!path || !enabled) return;
    try {
      const r = await http.get(path);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  }, [path, enabled]);

  useEffect(() => {
    setLoading(true);
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, ...deps]);

  useEffect(() => {
    if (!pollRef.current) return undefined;
    const id = setInterval(() => pollRef.current && load(), pollRef.current);
    return () => clearInterval(id);
  }, [load, poll]);

  return { data, error, loading, reload: load };
}
